export function calendarize(year: number, month: number): number[][] {
  let i = 0,
    j = 0,
    week: number[];

  const out: number[][] = [];

  // day index (of week) for 1st of month
  let first = new Date(year, month - 1, 1).getDay();

  // how many days there are in this month
  const days = new Date(year, month, 0).getDate();

  while (i < days) {
    for (j = 0, week = Array(7); j < 7; ) {
      while (j < first) week[j++] = 0;
      week[j++] = ++i > days ? 0 : i;
      first = 0;
    }
    out.push(week);
  }

  return out;
}
